import { ProductTypeParameter } from '@products/services/graphql-fund-data.service';
import { ProductDTO } from '@products/types';
import { Chip, DropdownItem } from '@frk/eds-components';
import { FilterType, OptionWithCount } from '@types';

export interface Records {
  showed: number;
  all: number;
}

export interface SubscriptionsParams {
  apiUrl: string;
  id: string;
  sectionType: string;
  frequency: boolean;
  scale?: string;
}

export interface GroupItems {
  id?: string;
  label?: string;
}

export interface GridHeader {
  id: string;
  name: string;
  type: string;
}

export interface GridRowData {
  HAS_SUBSCRIPTION?: boolean;
  ID: string;
  PRODUCT_ID: string;
  ASSET_CLASS: string;
  NAME: string;
  FACTSHEET?: boolean;
  PROSPECTUS?: boolean;
  COMMENTARY?: boolean;
  ATTRIBUTION?: boolean;
  PERFORMANCE?: boolean;
  ANNUAL_REPORT?: boolean;
  SEMIANNUAL_REPORT?: boolean;
  SUMMARY_PROSPECTUS?: boolean;
  PORTFOLIO_HOLDINGS?: boolean;
  PRODUCT_PROFILE?: boolean;
  STATEMENT?: boolean;
  isChecked?: boolean;
  documentTypes?: string;
  selectedDocuments?: Array<DocumentsData>;
  allActiveDocuments?: Array<ProductSubscriptionsDTO>;
  isExpanded?: boolean;
  selectedDocumentsCount?: number;
}

export interface ProductTypesData {
  region: string;
  investorType: string;
  productTypes: ProductType[];
}

export interface ProductType {
  typeId: string | ProductTypeParameter;
  typeLabel: string;
  typeOrder: string;
  documentTypes: DocumentType[];
}

export interface DocumentType {
  documentId: string;
  documentLabel: string;
  documentTypeId: string;
}

export interface SubscriptionProductsData {
  region: string;
  investorType: string;
  products: SubscriptionProductDTO[];
}

export interface SubscriptionProductDTO {
  productAssetClass: string;
  productLabel: string;
  productOneTis: string;
  productType: string;
  productTypeId: string;
  productId: string;
}

export interface SubscribedProductDTO {
  productId?: string;
  documentTypeId?: string;
  active: boolean;
  autoSubscribed: boolean;
  subscriptionId?: string;
  widenAssetId?: string;
}

export interface GqlProductData {
  data: {
    PPSS: ProductDTO[];
  };
}

export interface HttpOptions {
  [name: string]: string;
}

export interface SelectAllDocs {
  dataParams: GridRowData;
}

export enum SwitchState {
  OFF = 'off',
  ON = 'on',
}

export interface ApiParameters {
  [name: string]: string;
}

export interface ProductsUserData {
  contactId: string;
  globalId: string;
  region: string;
  investorType: string;
  globalUnsubscribe: boolean;
  subscriptions: ProductSubscriptionsDTO[];
}

export interface ContactData {
  contactId: string;
  globalId: string;
  region: string;
}
export interface ProductSubscriptionsDTO {
  productName?: string;
  productOneTis?: string;
  documentType: string;
  documentTypeId?: string;
  subscriptionId?: string;
  subscriptionName?: string;
  productId?: string;
  active?: boolean;
  autoSubscribed?: boolean;
  lastModifiedDate?: string;
  widenAssetId?: string;
  documentTypes?: string;
  category?: string;
  asOfDate?: string;
  isChecked?: boolean;
}

export interface SelectorChip {
  id: string;
  subscriptionPreferenceId?: string;
  selected: boolean;
  chips: Chip[];
}

export interface RowDataChange {
  changedDocuments: string[];
}

export type DropDownFilterType = FilterType & {
  preSelectedValues:
    | OptionWithCount
    | OptionWithCount[]
    | DropdownItem
    | DropdownItem[];
};

export interface DocumentsData {
  widenAssetId: string;
  documentTitle: string;
  documentType: string;
  documentId: string;
  category: string;
  asOfDate?: string;
  isChecked?: boolean;
  productName?: string;
}

export interface DocumentsResult {
  documents: DocumentsData[];
  requestParameters: RequestParameters;
}

export interface RequestParameters {
  productId: string;
  shareClass?: string;
  shareClassCurrency?: string;
  documentType?: string;
  language?: string;
}

export interface ConfigGroup {
  groupId: number;
  groupLabel: string;
  values?: Array<string>;
}

export interface SubscriptionPreferenceGroup {
  contactId: string;
  subscriptionPreferences: Array<SubscriptionPreference>;
}

export interface SearchFilterOptions {
  region: string;
  searchFilterOptions: Array<ConfigGroup>;
}

export interface UserConfigData {
  searchFilterOptions: SearchFilterOptions;
  subscriptionPreferences: SubscriptionPreferenceGroup;
}

export interface SubscriptionPreference {
  subscriptionPreferenceId?: string;
  dataElement: number;
  dataElementLabel?: string;
  dataValue: string;
  active: boolean;
}

export type SubscriptionProductFilterType = {
  filterLabel?: string;
  filterName: string;
  filterItems: DropdownItem[];
};

export enum FILTER_DEFAULT_TYPES {
  'pref-share-class' = 'Share Class',
  'pref-currency' = 'Currency',
  'pref-language' = 'Language',
  'pref-fund-type' = 'Fund Type',
  'pref-document-type' = 'Document Type',
  'pref-distribution' = 'Distribution',
  'pref-hedged' = 'Hedged',
}

export type SubscriptionProductFilterData = {
  region: string;
  searchFilterOptions: SubscriptionProductFilterOptions[];
};

export type SubscriptionProductFilterOptions = {
  groupId: string;
  groupLabel: string;
  values: string[];
};
export type SubscriptionProductSelectedFilters = {
  filterType: string;
  values: DropdownItem[];
};

export interface SubscriptionToggleOption {
  active: boolean;
  text: string;
  value?: string;
  disabled?: boolean;
}
